import { Alert, AlertTitle, List, ListItem, ListItemText } from '@mui/material';
import { useFormContext } from 'react-hook-form';

const FormErrorDisplayer = () => {
  const { formState: { errors } } = useFormContext();
  const flattenErrors = (errorObj: any, path: string[] = []): string[] => {
    if (!errorObj) return [];

    if (typeof errorObj === 'object') {
      if ('message' in errorObj) {
        return [errorObj.message as string];
      }

      return Object.keys(errorObj).flatMap((key) => {
        const newPath = [...path, key];
        const value = errorObj[key];
        
        if (Array.isArray(value)) {
          return value.flatMap((item, index) => 
            flattenErrors(item, [...newPath, String(index)])
          );
        }
        
        return flattenErrors(value, newPath);
      });
    }

    return [];
  };

  const errorMessages = flattenErrors(errors);

  if (errorMessages.length === 0) return null;

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      <AlertTitle>Form Errors</AlertTitle>
      <List dense sx={{ listStyleType: 'disc', pl: 2 }}>
        {errorMessages.map((message, index) => (
          <ListItem 
            key={index} 
            sx={{ display: 'list-item', p: 0, pl: 1 }}
          >
            <ListItemText primary={message} />
          </ListItem>
        ))}
      </List>
    </Alert>
  );
};

export default FormErrorDisplayer;